import React from 'react';

type Props = JSX.IntrinsicElements['a'];

const ExternalLink: React.FC<Props> = ({ target = '_blank', rel = 'noreferrer', ...rest }) => (
  <a target={target} rel={rel} {...rest} />
);

export default ExternalLink;
